export const nameRegex = /[^a-zA-Z\s-]/g;
export const cityRegex = /[^A-Za-z\s-]/g;
export const postCodeRegex = /[^\w\s-]/g;
export const addressRegex = /[^A-Za-z0-9\s!@#$%^&*(),.?":{}|<>\-\\/[\]`~+=_'–]/g;
export const countryCodeRegex = /[^+(\d+)$]/g;
export const datepickerRegex = /[^0-9-]/g;
export const nationalityRegex = /[^A-Za-z]/g;
